import {
  UPDATE_LOADING,
  UPDATE_ERROR,
  UPDATE_MESSAGE,
  SET_AUTH_DATA,
  SET_USER_TOKEN,
  UPDATE_USER_AVATAR,
  SET_TENANT_SUB,
} from 'constants/ActionTypes';

export function AuthReducer(draft, action) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_LOADING:
      draft.loading = payload;
      return;
    case UPDATE_MESSAGE:
      draft.message = payload;
      draft.error = '';
      return;
    case UPDATE_ERROR:
      draft.error = payload;
      draft.message = '';
      return;
    case SET_TENANT_SUB:
      draft.sub = payload;
      return;
    case SET_AUTH_DATA:
      draft.authUser = payload;
      return;
    case SET_USER_TOKEN:
      draft.token = payload;
      return;
    case UPDATE_USER_AVATAR:
      draft.authUser.avatar = payload;
      return;
    default:
      return draft;
  }
}
